<template>
  <div class="admin-page">
    <Header />
    <div class="header-actions">
      <h2 class="title"><i class="fa-solid fa-user-shield"></i> Gestão de Usuários</h2>
      <div class="header-actions-buttons">
        <button class="btn-create" @click="openModal()"><i class="fa-solid fa-plus"></i> Novo Usuário</button>
        <router-link to="/admin/dashboard" class="btn-back">Voltar ao Painel</router-link>
      </div>
    </div>

    <div class="card-panel">
      <div class="table-responsive">
        <table class="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Nome & Email</th>
              <th>Instituição</th>
              <th>Tipo</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in users" :key="user.id">
              <td>#{{ user.id }}</td>
              <td><strong>{{ user.name }}</strong><br/><small>{{ user.email }}</small></td>
              <td>{{ user.institution || '-' }}</td>
              <td>
                {{ getUserTypeName(user.type) }}
                <small v-if="user.type === 'admin' && user.is_admin" class="text-success" style="display:block; font-size:0.75rem;">(Acesso Total)</small>
              </td>
              <td>
                <span :class="['status-badge', user.active ? 'active' : 'inactive']">
                  {{ user.active ? 'Ativo' : 'Inativo' }}
                </span>
              </td>
              <td>
                <button class="btn-action view" title="Editar Usuário" @click="openModal(user)"><i class="fa-solid fa-pen"></i></button>
                <button class="btn-action toggle" @click="toggleStatus(user)" :title="user.active ? 'Inativar' : 'Ativar'">
                  <i :class="['fa-solid', user.active ? 'fa-lock' : 'fa-unlock']"></i>
                </button>
                <button class="btn-action reset-pw" @click="resetPassword(user)" title="Enviar Email de Redefinição">
                  <i class="fa-solid fa-key"></i>
                </button>
              </td>
            </tr>
            <tr v-if="users.length === 0">
              <td colspan="6" class="text-center">Nenhum usuário encontrado.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Criar/Editar Usuário -->
    <div class="partner-modal-overlay" v-if="showModal">
      <div class="partner-modal-content create-modal">
        <button class="close-btn" @click="closeModal"><i class="fa-solid fa-times"></i></button>
        <h3><i class="fa-solid" :class="isEditing ? 'fa-pen' : 'fa-user-plus'"></i> {{ isEditing ? 'Editar Usuário' : 'Novo Usuário' }}</h3>
        
        <form @submit.prevent="saveUser" class="create-partner-form">
          <div class="form-group">
            <label>Nome Completo</label>
            <input type="text" v-model="form.name" required placeholder="Ex: Maria da Silva" />
          </div>
          <div class="form-group">
            <label>Email</label>
            <input type="email" v-model="form.email" required placeholder="Ex: maria@xyz.com" />
          </div>
          <div class="form-group">
            <label>Instituição</label>
            <input type="text" v-model="form.institution" placeholder="Ex: Faculdade XYZ" />
          </div>
          <div class="form-group">
            <label>Tipo de Usuário</label>
            <select v-model="form.type" required>
              <option value="" disabled>Selecione um tipo</option>
              <option value="admin">Administrador do Sistema</option>
              <option value="manager">Gestor / Coordenador</option>
              <option value="user">Usuário Padrão</option>
            </select>
          </div>
          <div class="form-group" v-if="form.type === 'admin'">
            <label>Privilégios Administrativos</label>
            <div class="checkbox-wrapper">
              <input type="checkbox" id="isAdminCheck" v-model="form.is_admin" />
              <label for="isAdminCheck">Conceder acesso total</label>
            </div>
          </div>
          <div class="form-group" v-else>
            <!-- Spacer to maintain grid layout when checkbox is hidden -->
          </div>
          <div class="form-group">
            <label>Status</label>
            <select v-model="form.active">
              <option :value="true">Ativo</option>
              <option :value="false">Inativo</option>
            </select>
          </div>
          
          <div class="form-actions">
            <button type="button" class="btn-cancel" @click="closeModal">Cancelar</button>
            <button type="submit" class="btn-save">Salvar Usuário</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import requestV2 from '@/router/requestV2';
import '@/styles/Admin.css';

export default {
  name: 'AdminUsers',
  components: { Header },
  data() {
    return {
      users: [],
      showModal: false,
      isEditing: false,
      form: {
        id: null,
        name: '',
        email: '',
        institution: '',
        type: '',
        is_admin: false,
        active: true
      }
    }
  },
  watch: {
    'form.type'(newVal) {
      if (newVal !== 'admin') {
        this.form.is_admin = false;
      }
    }
  },
  mounted() {
    this.loadUsers();
  },
  methods: {
    async loadUsers() {
      try {
        const response = await requestV2.get('/users/usuarios');
        this.users = response.data.map(u => ({
          id: u.id,
          name: u.nome_usuario,
          email: u.email,
          institution: u.nome_instituicao,
          type: u.codigo_perfil == 1 ? 'admin' : (u.codigo_perfil == 4 ? 'manager' : 'user'),
          is_admin: u.is_admin == 1,
          active: u.active == 1
        }));
      } catch (err) {
        console.error('Erro ao carregar usuários:', err);
      }
    },
    getUserTypeName(type) {
      if (type === 'admin') return 'Administrador';
      if (type === 'manager') return 'Gestor';
      return 'Usuário Padrão';
    },
    async toggleStatus(user) {
      try {
        const newStatus = !user.active;
        await requestV2.put(`/users/usuarios/${user.id}`, { active: newStatus });
        user.active = newStatus;
      } catch (err) {
        console.error('Erro ao alterar status:', err);
        alert('Erro ao alterar status do usuário.');
      }
    },
    async resetPassword(user) {
      try {
        await requestV2.post(`/users/usuarios/${user.id}/reset-password`);
        alert('Email de redefinição de senha enviado com sucesso!');
      } catch (err) {
        console.error(err);
        alert('Erro ao enviar email de redefinição.');
      }
    },
    openModal(user = null) {
      if (user) {
        this.isEditing = true;
        this.form = { ...user };
      } else {
        this.isEditing = false;
        this.form = {
          id: null,
          name: '',
          email: '',
          institution: '',
          type: '',
          is_admin: false,
          active: true
        };
      }
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    async saveUser() {
      try {
        if (this.isEditing) {
          await requestV2.put(`/users/usuarios/${this.form.id}`, this.form);
          alert('Usuário atualizado com sucesso!');
        } else {
          await requestV2.post('/users/usuarios', this.form);
          alert('Usuário criado com sucesso!');
        }
        this.closeModal();
        this.loadUsers();
      } catch (err) {
        console.error('Erro ao salvar usuário:', err);
        alert('Erro ao salvar usuário.');
      }
    }
  }
}
</script>

<style scoped>
.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-actions-buttons {
  display: flex;
  gap: 15px;
  align-items: center;
}
.btn-create {
  background: #FEC401;
  color: #09105D;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-family: 'Outfit', sans-serif;
  font-weight: 600;
  transition: 0.3s;
}
.btn-create:hover {
  background: #e5b000;
  box-shadow: 0 4px 15px rgba(254, 196, 1, 0.3);
}

.partner-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.partner-modal-content {
  background: #09105D;
  border: 1px solid rgba(255,255,255,0.2);
  border-radius: 16px;
  padding: 30px;
  width: 90%;
  max-width: 800px;
  position: relative;
  box-shadow: 0 15px 40px rgba(0,0,0,0.5);
  color: #fff;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 1.5rem;
  cursor: pointer;
}

.create-modal h3 {
  color: #FEC401;
  margin-top: 0;
  margin-bottom: 25px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
  padding-bottom: 15px;
}

.create-partner-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  color: #FEC401;
  margin-bottom: 8px;
  font-size: 0.9rem;
}

.form-group input[type="text"], 
.form-group input[type="email"], 
.form-group select {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 12px;
  border-radius: 8px;
  color: #fff;
  font-family: 'Outfit', sans-serif;
}

.form-group input:focus, .form-group select:focus {
  outline: none;
  border-color: #FEC401;
}

.form-group select option {
  background: #09105D;
  color: #fff;
}

.form-group ::placeholder{
  color: #a1a1a1;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 0;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding-left: 12px;
  border: 1px solid rgba(255,255,255,0.1);
}

.checkbox-wrapper input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #FEC401;
  cursor: pointer;
}

.checkbox-wrapper label {
  color: #fff;
  margin: 0;
  font-size: 0.95rem;
  cursor: pointer;
}

.form-actions {
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 20px;
}

.btn-cancel {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: none;
  padding: 12px 25px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
}
.btn-cancel:hover {
  background: rgba(255, 255, 255, 0.2);
}

.btn-save {
  background: #FEC401;
  color: #09105D;
  border: none;
  padding: 12px 25px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: 0.3s;
}
.btn-save:hover {
  background: #e5b000;
}

.btn-action.reset-pw:hover {
  color: #9b59b6;
}

.text-success {
  color: #2ecc71;
}

@media (max-width: 768px) {
  .create-partner-form {
    grid-template-columns: 1fr;
  }
}
</style>
